import { render, staticRenderFns } from "./MessagesLimit.vue?vue&type=template&id=bbd843a6&scoped=true&"
import script from "./MessagesLimit.vue?vue&type=script&lang=js&"
export * from "./MessagesLimit.vue?vue&type=script&lang=js&"
import style0 from "./MessagesLimit.vue?vue&type=style&index=0&id=bbd843a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd843a6",
  null
  
)

export default component.exports